const SVG_VECTOR_PREFIX = 'vector';
export const getVectorId = (id: string) => `${SVG_VECTOR_PREFIX}-${id}`;
